import { useEffect, useState } from "react";
import { API, fmtTgl, rupiah, pesanGalat } from "../lib/api";
import Shell from "../components/Shell";
import TanggalPilihan from "../components/TanggalPilihan";
import { JudulHalaman, KerangkaBaris, KeadaanGalat, KELAS_TABEL, KELAS_TH, KELAS_TD } from "../components/kit";

const PRESET = [
  ["akun_tak_bertuan", "Akun hidup tanpa pemilik sebelum pakai PAM-IT", "akun",
    "Dihitung sekali dari daftar akun lama, cth. sapuan akun 12 Jun 2026"],
  ["waktu_tutup_manual_menit", "Waktu mengurus satu penutupan secara manual", "menit",
    "Diukur dengan stopwatch saat satu pencabutan manual"],
  ["permintaan_non_akses_per_minggu", "Permintaan non-akses per minggu sebelum tercatat", "catatan",
    "Hitungan kasar dari catatan lama, cth. rekap grup pesan sepekan"],
];

export default function AngkaDasar() {
  const [dasar, setDasar] = useState(null);
  const [biaya, setBiaya] = useState(null);
  const [sistem, setSistem] = useState([]);
  const [galat, setGalat] = useState(null);
  const [d, setD] = useState({ metrik: "", nilai_sebelum: "", satuan: "", sumber: "", tanggal_ukur: new Date().toISOString().slice(0, 10), metode: "", n: "" });
  const [b, setB] = useState({ sistem_id: "", vendor: "", nomor_invoice: "", harga_per_kursi_tertulis: "", tanggal_invoice: new Date().toISOString().slice(0, 10) });

  const muat = () => {
    setGalat(null);
    API.get("/dasar").then((r) => setDasar(r.data)).catch((e) => setGalat(pesanGalat(e)));
    API.get("/biaya-lisensi").then((r) => setBiaya(r.data)).catch(() => {});
    API.get("/sistem").then((r) => setSistem(r.data)).catch(() => {});
  };
  useEffect(muat, []);

  const simpanDasar = async (e) => {
    e.preventDefault();
    try {
      await API.post("/dasar", { ...d, nilai_sebelum: parseFloat(d.nilai_sebelum), n: d.n === "" ? null : parseInt(d.n) });
      setD({ ...d, metrik: "", nilai_sebelum: "", sumber: "", metode: "", n: "" });
      muat();
    } catch (err) { alert(pesanGalat(err)); }
  };
  const simpanBiaya = async (e) => {
    e.preventDefault();
    try {
      await API.post("/biaya-lisensi", { ...b, harga_per_kursi_tertulis: parseFloat(b.harga_per_kursi_tertulis), sistem_id: b.sistem_id });
      setB({ ...b, vendor: "", nomor_invoice: "", harga_per_kursi_tertulis: "" });
      muat();
    } catch (err) { alert(pesanGalat(err)); }
  };

  return (
    <Shell>
      <JudulHalaman testid="judul-dasar" judul="Angka Dasar & Invoice"
        sub="Simpan angka pembanding dengan sumber yang jelas. Nilai rupiah hanya berasal dari invoice yang tercatat." />
      {galat && <KeadaanGalat testid="galat-dasar" pesan={galat} onCoba={muat} />}

      <section className="grid md:grid-cols-2 gap-6">
        <form onSubmit={simpanDasar} className="border p-4 space-y-3" data-testid="form-dasar">
          <h2 className="font-heading font-semibold">Catat angka pembanding</h2>
          <p className="text-xs text-muted-foreground">
            Tiga angka di bawah ini yang dipakai halaman Bukti Dampak. Pilih salah satu, isi angka nyata
            perusahaan Anda beserta sumbernya, lalu simpan.
          </p>
          <select data-testid="pilih-preset-dasar" value={PRESET.some(([k]) => k === d.metrik) ? d.metrik : "lain"}
            onChange={(e) => {
              const p = PRESET.find(([k]) => k === e.target.value);
              setD(p ? { ...d, metrik: p[0], satuan: p[2], metode: d.metode || p[3] } : { ...d, metrik: "" });
            }}
            className="w-full border bg-background px-2 py-1.5 text-sm">
            <option value="lain">— angka lain (tulis sendiri) —</option>
            {PRESET.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <input data-testid="input-metrik-dasar" required placeholder="Metrik (cth. waktu_tutup_manual_menit)" value={d.metrik}
            onChange={(e) => setD({ ...d, metrik: e.target.value })} className="w-full border bg-background px-2 py-1.5 text-sm" />
          <div className="grid grid-cols-2 gap-2">
          <input data-testid="input-nilai-dasar" required type="number" step="any" placeholder="Nilai pembanding" value={d.nilai_sebelum}
              onChange={(e) => setD({ ...d, nilai_sebelum: e.target.value })} className="border bg-background px-2 py-1.5 text-sm" />
            <input data-testid="input-satuan-dasar" required placeholder="Satuan" value={d.satuan}
              onChange={(e) => setD({ ...d, satuan: e.target.value })} className="border bg-background px-2 py-1.5 text-sm" />
          </div>
          <input data-testid="input-sumber-dasar" required placeholder='Sumber yang bisa diperiksa (cth. "stopwatch 1 pencabutan manual, 24 Agu 2026")'
            value={d.sumber} onChange={(e) => setD({ ...d, sumber: e.target.value })} className="w-full border bg-background px-2 py-1.5 text-sm" />
          <input data-testid="input-metode-dasar" placeholder="Metode ukur" value={d.metode}
            onChange={(e) => setD({ ...d, metode: e.target.value })} className="w-full border bg-background px-2 py-1.5 text-sm" />
          <div className="grid grid-cols-2 gap-2">
            <TanggalPilihan
              id="tanggal-dasar"
              label="Tanggal pengukuran"
              nilai={d.tanggal_ukur}
              onUbah={(tanggal) => setD({ ...d, tanggal_ukur: tanggal })}
              testid="input-tanggal-dasar"
            />
            <input data-testid="input-n-dasar" type="number" placeholder="n" value={d.n}
              onChange={(e) => setD({ ...d, n: e.target.value })} className="border bg-background px-2 py-1.5 text-sm" />
          </div>
          <button data-testid="btn-simpan-dasar" disabled={!d.sumber.trim()}
            className="px-4 py-2 bg-primary text-primary-foreground text-sm font-medium transition-colors duration-150 hover:opacity-90 disabled:opacity-40">
            Simpan angka pembanding
          </button>
        </form>

        <form onSubmit={simpanBiaya} className="border p-4 space-y-3" data-testid="form-biaya">
          <h2 className="font-heading font-semibold">Catat biaya lisensi dari invoice</h2>
          <select data-testid="pilih-sistem-biaya" required value={b.sistem_id}
            onChange={(e) => setB({ ...b, sistem_id: e.target.value })} className="w-full border bg-background px-2 py-1.5 text-sm">
            <option value="">— pilih akses —</option>
            {sistem.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
          </select>
          <input data-testid="input-vendor" required placeholder="Vendor" value={b.vendor}
            onChange={(e) => setB({ ...b, vendor: e.target.value })} className="w-full border bg-background px-2 py-1.5 text-sm" />
          <input data-testid="input-invoice" required placeholder="Nomor invoice (persis seperti tertulis)" value={b.nomor_invoice}
            onChange={(e) => setB({ ...b, nomor_invoice: e.target.value })} className="w-full border bg-background px-2 py-1.5 text-sm" />
          <div className="grid grid-cols-2 gap-2">
            <input data-testid="input-harga-kursi" required type="number" step="any" placeholder="Harga per kursi tertulis" value={b.harga_per_kursi_tertulis}
              onChange={(e) => setB({ ...b, harga_per_kursi_tertulis: e.target.value })} className="border bg-background px-2 py-1.5 text-sm" />
            <TanggalPilihan
              id="tanggal-invoice"
              label="Tanggal invoice"
              nilai={b.tanggal_invoice}
              onUbah={(tanggal) => setB({ ...b, tanggal_invoice: tanggal })}
              testid="input-tanggal-invoice"
            />
          </div>
          <button data-testid="btn-simpan-biaya" disabled={!b.nomor_invoice.trim()}
            className="px-4 py-2 bg-primary text-primary-foreground text-sm font-medium transition-colors duration-150 hover:opacity-90 disabled:opacity-40">
            Simpan (tanpa nomor invoice, rupiah tidak tampil)
          </button>
        </form>
      </section>

      <div className="grid md:grid-cols-2 gap-6 mt-8">
        <section>
          <h3 className="font-heading font-semibold mb-2">Angka pembanding</h3>
          {!dasar ? <KerangkaBaris testid="memuat-dasar" n={2} /> : (
            <div className="overflow-x-auto border">
              <table className={KELAS_TABEL} data-testid="tabel-dasar-admin">
                <thead><tr><th className={KELAS_TH}>Metrik</th><th className={KELAS_TH}>Nilai</th><th className={KELAS_TH}>Sumber</th></tr></thead>
                <tbody>
                  {dasar.map((x) => (
                    <tr key={x.id}>
                      <td className={KELAS_TD}>{x.metrik}</td>
                      <td className={`${KELAS_TD} font-data`}>{x.nilai_sebelum} {x.satuan}</td>
                      <td className={`${KELAS_TD} text-xs`}>{x.sumber}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
        <section>
          <h3 className="font-heading font-semibold mb-2">Invoice tercatat</h3>
          {!biaya ? <KerangkaBaris testid="memuat-biaya" n={2} /> : (
            <div className="overflow-x-auto border">
              <table className={KELAS_TABEL} data-testid="tabel-biaya">
                <thead><tr><th className={KELAS_TH}>Vendor</th><th className={KELAS_TH}>Invoice</th><th className={KELAS_TH}>Harga/kursi</th><th className={KELAS_TH}>Akses</th></tr></thead>
                <tbody>
                  {biaya.map((x) => (
                    <tr key={x.id}>
                      <td className={KELAS_TD}>{x.vendor}</td>
                      <td className={`${KELAS_TD} font-data`}>{x.nomor_invoice}</td>
                      <td className={`${KELAS_TD} font-data`}>{rupiah(x.harga_per_kursi_tertulis)}</td>
                      <td className={KELAS_TD}>{x.sistem_label}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </Shell>
  );
}
